package com.eladfinish.bible.contest.screens.chapterComplete.usecases

import com.eladfinish.bible.contest.common.usecases.PartitionChapterUseCase
import com.eladfinish.bible.contest.constants.StringConstants
import com.eladfinish.bible.contest.constants.StringConstants.HTML_LINE_BREAK
import com.eladfinish.bible.contest.constants.StringConstants.SEGOLTA
import com.eladfinish.bible.contest.constants.StringConstants.ZAQEF_QATON
import com.eladfinish.bible.contest.data.VerseEntity
import com.eladfinish.bible.contest.domain.BooksRepository.bookNamesHebrew
import com.eladfinish.bible.contest.extensions.replaceRegex
import com.eladfinish.bible.contest.screens.browse.usecases.GetIyovTehilimSpeakersUseCase
import com.eladfinish.bible.contest.screens.browse.usecases.GetIyovTehilimSpeakersUseCase.Companion.getVerseSpeaker
import com.eladfinish.bible.contest.utils.gematriaWord
import com.eladfinish.bible.contest.utils.toOtiot
import io.github.aakira.napier.Napier
import kotlinx.coroutines.withContext
import kotlin.coroutines.CoroutineContext

class BuildVerseEntitiesFromChapterUseCase(
    private val getIyovTehilimSpeakersUseCase: GetIyovTehilimSpeakersUseCase,
    private val partitionChapterUseCase: PartitionChapterUseCase,
) {

    suspend operator fun invoke(
        coroutineContext: CoroutineContext,
        bookNumber: Int,
        chapterNumber: Int,
        chapterContent: String,
        isFromSifreyEmet: Boolean,
    ): List<VerseEntity> = withContext(coroutineContext) {

        val iyovSpeakers = getIyovTehilimSpeakersUseCase.getIyovSpeakers()
        val tehilimAuthors = getIyovTehilimSpeakersUseCase.getTehilimAuthors()

        val partitionedChapter = partitionChapterUseCase(chapter = chapterContent, isFromSifreyEmet = isFromSifreyEmet)
        val versesList = mutableListOf<VerseEntity>()
        val booksArray = bookNamesHebrew
        for (verse in partitionedChapter) {
            val otPasuk = verse[0][0]
            var reysha = getVersePart(1, verse).trim()
            var seyfa = getVersePart(2, verse).trim()
            if (isFromSifreyEmet && verse.size == 4) { //sometimes verses from EMET have 3 parts
                seyfa += HTML_LINE_BREAK + getVersePart(3, verse)
            }
            if (isFromSifreyEmet) {
                // למעשה, התנאי הזה נועד לבדוק רק את ספר איוב (ולא את תהילים ומשלי)
                // ומטרת הקוד היא לשבור שורה אחרי זקף קטון שמופיע בסיפא
                val shouldBreakLines = true
                if (shouldBreakLines) {
                    reysha = reysha.breakLineAfterZaqefTaamMafsiq(taam = ZAQEF_QATON)
                    reysha = reysha.breakLineAfterZaqefTaamMafsiq(taam = SEGOLTA)
                    seyfa = seyfa.breakLineAfterZaqefTaamMafsiq(taam = ZAQEF_QATON)
                }
            }
            seyfa += StringConstants.COLON_SPLITTER
            val pickedBookHeb = booksArray[bookNumber - 1]

            val extraData = when (pickedBookHeb) {
                "תהילים" -> tehilimAuthors.getVerseSpeaker(
                    chapter = chapterNumber,
                    verse = otPasuk.gematriaWord(),
                    default = "",
                )

                "איוב" -> iyovSpeakers.getVerseSpeaker(
                    chapter = chapterNumber,
                    verse = otPasuk.gematriaWord(),
                    default = "איוב",
                )

                else -> null
            }

            val verseEntity = VerseEntity(
                bookIndex = bookNumber,
                strBook = pickedBookHeb,
                strChapter = chapterNumber.toOtiot(),
                strVerse = otPasuk,
                strPasuk = "$reysha $seyfa",
                strReysah = reysha,
                strSeyfa = seyfa,
                strExtraData = extraData,
            )
            versesList.add(verseEntity)
        }
        versesList
    }

    private fun String.breakLineAfterZaqefTaamMafsiq(taam: Char = ZAQEF_QATON): String {
        val taamMafsiqIndex = indexOf(taam)
        if (taamMafsiqIndex != -1) {
            indexOf(" ", taamMafsiqIndex).let {
                Napier.d("taamMafsiqIndex $taamMafsiqIndex, spaceAfterTaamMafsiqIndex $it")
                if (it != -1) {
//                    substringBefore()
//                    substringAfter()
                    return take(it) + HTML_LINE_BREAK + substring(it + 1)
                }
            }
        }
        return this
    }

    private fun getVersePart(part: Int, verses: List<List<String>>): String =
        verses[part].joinToString(separator = " ")
            .replaceRegex(
                regex = "${StringConstants.MAKAF} ",
                replacement = StringConstants.MAKAF.toString()
            )

}
